import {
  createColumn,
  formatDateTime,
  numberFormat,
} from "../../utils/helpers";
import { TFieldConfig } from "../../types/common";
import { API_INVOICES_PAID_ALL } from "../../utils/apis";
import {
  BooleanTags,
  PaymentStatusTag,
} from "../../components/common/registerUtils";

interface UseVehicleLedgerSearchProps {
  form: any;
  updateFormValue: (field: string, value: any) => void;
  updateFormValues: (values: any) => void;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  filters: any;
  setFilters: (filters: any) => void;
  setError: (error: any) => void;
}

export const useVehicleLedgerSearch = ({}: UseVehicleLedgerSearchProps) => {
  const searchFields: TFieldConfig[] = [
    {
      field_name: "car_number",
      label: "Vehicle Plate Number",
      type: "text",
      props: {
        placeholder: "Enter vehicle plate number",
        required: true,
      },
    },
  ];

  const tableColumns = () => [
    createColumn("invoice_number", false, "Invoice Number"),
    createColumn("generated_at", false, "Generated At"),
    createColumn("amount", false, "Amount Assessed"),
    createColumn("amount_paid", false, "Amount Paid"),
    createColumn("balance", false, "Balance"),
    createColumn("payment_status", true, "Payment Status"),
    createColumn("type", true, "Type"),
    createColumn("exempted", false, "Exempted"),
  ];

  const tableData = (data: any) => {
    if (!data) return [];

    return data?.results?.map((item: any) => ({
      ...item,
      invoice_number: item.invoice_number || "N/A",
      generated_at: formatDateTime(item.generated_at) || "N/A",
      amount: item.amount ? numberFormat(item.amount) : "N/A",
      amount_paid: item.amount_paid ? numberFormat(item.amount_paid) : "N/A",
      balance: item.total_due ? numberFormat(item.total_due) : "0",
      payment_status: <PaymentStatusTag status={item.payment_status} />,
      type: item.type || "N/A",
      exempted: <BooleanTags status={item.exempted} />,
    }));
  };

  const api = API_INVOICES_PAID_ALL;
  const tableTitle = "Vehicle Search Results";
  const initialFilters = {};

  return {
    searchFields,
    tableColumns,
    tableData,
    tableTitle,
    api,
    initialFilters,
  };
};
